export const banners = [
  {
    id: "banner-01",
    movieId: "mv-01",
    title: "星际裂痕",
    subtitle: "时空裂痕开启，人类命运悬于一线",
    tag: "最新热播",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20sci-fi%20scene%20of%20a%20giant%20glowing%20blue%20rift%20splitting%20a%20dark%20starfield%2C%20a%20tiny%20spaceship%20silhouette%20approaching%20it%2C%20deep%20blue%20and%20cyan%20nebulae%20with%20warm%20amber%20accent%20light%2C%20epic%20dramatic%20lighting%2C%20spacious%20composition%20with%20dark%20areas%20for%20text%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-banner01&orientation=landscape",
  },
  {
    id: "banner-02",
    movieId: "mv-10",
    title: "沙丘信使",
    subtitle: "穿越风暴的旅程，改写荒漠的未来",
    tag: "口碑之作",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20desert%20sci-fi%20scene%20of%20endless%20towering%20sand%20dunes%20under%20a%20huge%20pale%20moon%20and%20deep%20blue%20twilight%20sky%2C%20a%20lone%20figure%20in%20a%20flowing%20cloak%20walking%2C%20warm%20orange%20sand%20highlights%20with%20deep%20blue%20shadows%2C%20epic%20composition%20with%20dark%20areas%20for%20text%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-banner02&orientation=landscape",
  },
  {
    id: "banner-03",
    movieId: "mv-13",
    title: "长夜将明",
    subtitle: "长夜漫长，他们相信黎明终将到来",
    tag: "年代大剧",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20period%20drama%20scene%20of%20a%20rainy%20old%20town%20street%20at%20night%20with%20warm%20streetlamps%20and%20deep%20blue%20sky%2C%20vintage%20architecture%20and%20reflective%20wet%20ground%2C%20several%20figures%20in%20long%20coats%20walking%2C%20moody%20composition%20with%20dark%20areas%20for%20text%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-banner03&orientation=landscape",
  },
  {
    id: "banner-04",
    movieId: "mv-22",
    title: "灵剑山海",
    subtitle: "携一柄灵剑，踏上修行与寻真之路",
    tag: "国漫热播",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20Chinese%20fantasy%20anime%20scene%20of%20misty%20floating%20mountains%20with%20glowing%20jade%20sword%20light%20and%20a%20young%20swordsman%20silhouette%2C%20deep%20blue%20peaks%20with%20warm%20golden%20accents%2C%20epic%20composition%20with%20dark%20areas%20for%20text%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-banner04&orientation=landscape",
  },
];